import script from "./participant-step1.vue?vue&type=script&setup=true&lang=ts"
export * from "./participant-step1.vue?vue&type=script&setup=true&lang=ts"

import "./participant-step1.vue?vue&type=style&index=0&id=1859b65a&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/1/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1859b65a"]])

export default __exports__